import moment from 'moment';
export const UNPLANNED_TASKS_DROPPABLE_ID = 'unplanned-tasks';
export const UNPLANNED_DRAG_PREFIX = 'unplanned:';
// Main tasks and subtasks are on by default; to-dos are opt-in.
export const DEFAULT_UNPLANNED_TASK_LEVELS = [0, 1];
export const createDefaultUnplannedTasksFilters = () => ({
    userIsNextAssignedUser: true,
    taskLevels: [...DEFAULT_UNPLANNED_TASK_LEVELS],
    taskTemplates: [],
    subtaskTemplate: undefined,
    // Default window starts a year back: old never-finished tasks stay out unless asked for.
    deadlineFrom: moment()
        .subtract(1, 'year')
        .toISOString(),
    deadlineUntil: undefined,
    relationId: undefined,
    requiresDuration: false,
});
export const countActiveUnplannedTasksFilters = (filters) => {
    var _a;
    let count = 0;
    if (filters.userIsNextAssignedUser === false)
        count += 1;
    if (filters.requiresDuration === true)
        count += 1;
    // Count "task level" as active only when it deviates from the default selection, otherwise
    // to-dos being off by default would permanently read as an active filter.
    const taskLevels = (_a = filters.taskLevels) !== null && _a !== void 0 ? _a : [];
    const isDefaultTaskLevels = taskLevels.length === DEFAULT_UNPLANNED_TASK_LEVELS.length &&
        DEFAULT_UNPLANNED_TASK_LEVELS.every(level => taskLevels.includes(level));
    if (!isDefaultTaskLevels)
        count += 1;
    if (filters.taskTemplates && filters.taskTemplates.length > 0)
        count += 1;
    if (filters.subtaskTemplate)
        count += 1;
    // deadlineFrom has a non-empty default (a year back) — count only deviations from it,
    // compared by day so the check doesn't depend on ISO-string identity.
    const isDefaultDeadlineFrom = !!filters.deadlineFrom &&
        moment(filters.deadlineFrom).isSame(moment().subtract(1, 'year'), 'day');
    if (!isDefaultDeadlineFrom)
        count += 1;
    if (filters.deadlineUntil)
        count += 1;
    if (filters.relationId)
        count += 1;
    return count;
};
